import { useMemo } from "react";
import { REVENUE_CODE_STRUCTURE, revenueCodeNodeTitle, segmentsForRevenueNode } from "../lib/legalTaxonomy";
import { segmentLabel } from "../lib/legalSections";
import { useLocale } from "../lib/LocaleProvider";

function TreeNode({ node, segments, sourceSegments, documentResult, onOpenSection, depth = 0 }) {
  const { locale, text } = useLocale();
  const matched = useMemo(() => segmentsForRevenueNode(node, segments, sourceSegments), [node, segments, sourceSegments]);
  const title = revenueCodeNodeTitle(node, locale);
  const hasChildren = Boolean(node.children?.length || matched.length);
  if (!hasChildren) {
    return (
      <li className="law-tree-source-only" style={{ "--tree-depth": depth }}>
        <button
          className="law-tree-source-only-button"
          type="button"
          disabled
          title={text("common.notAvailable")}
          lang={locale}
        >
          {title}
        </button>
      </li>
    );
  }
  return (
    <li style={{ "--tree-depth": depth }}>
      <details open={depth === 0}>
        <summary>
          <span lang={locale}>{title}</span>
        </summary>
        {node.children?.length ? (
          <ol>
            {node.children.map((child) => (
              <TreeNode key={child.id} node={child} segments={segments} sourceSegments={sourceSegments} documentResult={documentResult} onOpenSection={onOpenSection} depth={depth + 1} />
            ))}
          </ol>
        ) : (
          <ol className="law-tree-sections">
            {matched.map((segment) => (
              <li key={`${segment.sequence}-${segment.locator || "section"}`}>
                <button type="button" onClick={() => onOpenSection(documentResult, segment.sequence)} lang={documentResult.language || locale}>
                  {segmentLabel(segment, documentResult.language || locale)}
                </button>
              </li>
            ))}
          </ol>
        )}
      </details>
    </li>
  );
}

export default function RevenueCodeTree({ bundle, sourceBundle, documentResult, onOpenSection }) {
  const { text } = useLocale();
  if (!bundle || !documentResult) return <p className="browse-state">{text("browse.loading")}</p>;
  return (
    <section className="revenue-code-browser" aria-label={text("browse.detailContents")}>
      <div className="revenue-code-browser-heading"><strong>{text("browse.detailContents")}</strong></div>
      <ol className="law-tree">
        <TreeNode node={REVENUE_CODE_STRUCTURE} segments={bundle.segments || []} sourceSegments={(sourceBundle || bundle).segments || []} documentResult={documentResult} onOpenSection={onOpenSection} />
      </ol>
    </section>
  );
}
